var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 127,
    viewBox: "0 0 128 127",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 119.062C94.9279 119.062 120 94.1863 120 63.5C120 32.8137 94.9279 7.9375 64 7.9375C33.0721 7.9375 8 32.8137 8 63.5C8 94.1863 33.0721 119.062 64 119.062Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2658 38.6291L55.9991 74.6124L41.0658 59.7958L33.5991 67.2041L55.9991 89.4291L99.7324 46.0374L92.2658 38.6291Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-icon.512c66ee.svg";
export { ForwardRef as ReactComponent };